import { render, staticRenderFns } from "./ManageSalesResources.vue?vue&type=template&id=881c57ea&scoped=true"
import script from "./ManageSalesResources.vue?vue&type=script&lang=js"
export * from "./ManageSalesResources.vue?vue&type=script&lang=js"
import style0 from "./ManageSalesResources.vue?vue&type=style&index=0&id=881c57ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881c57ea",
  null
  
)

export default component.exports